"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = __importDefault(require("@emotion/styled"));
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var StyledMenu = (0, styled_1.default)(function (props) { return ((0, jsx_runtime_1.jsx)(material_1.Menu, __assign({ elevation: 0, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    }, PaperProps: {
        elevation: 0,
        sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
            },
            '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
            },
        },
    } }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 180,
            color: theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
            boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
                padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                '&:active': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                },
                '&.error > *': {
                    color: theme.palette.error.main,
                },
            },
        },
    });
});
var MenuComponent = function (_a) {
    var _b;
    var target = _a.target, renderItems = _a.renderItems;
    var _c = react_1.default.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: { cursor: 'pointer' }, "aria-controls": open ? 'menu-component' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick }, { children: target })), (0, jsx_runtime_1.jsx)(StyledMenu, __assign({ id: "menu-component", MenuListProps: {
                    'aria-labelledby': 'button-menu-component',
                }, anchorEl: anchorEl, open: open, onClose: handleClose }, { children: (_b = renderItems(handleClose)) !== null && _b !== void 0 ? _b : 'Sin opciones' }))] }));
};
exports.default = MenuComponent;
